export default {
	aiCompanion: 'AI Companion',
	auction: 'Live sale',
	buyItNow: 'Buy it now',
	shortlist: 'Shortlist',
};
